export enum Size {
    large = "large",
    medium = "medium",
    small = "small",
    nano = "nano"
}

export type LoadingIndicatorProps = {
    className?: string;
    size?: Size;
}

export type LoadingIndicatorState = {

}
